export enum ModuleNames {
  app = 'app',
  patient = 'patient',
  detailedPatient = 'detailedPatient',
  exercise = 'exercise',
  exerciseProgram = 'exerciseProgram',
  siteStats = 'siteStats',
  siteReadings = 'siteReadings',
  siteGateways = 'siteGateways',
  site = 'site',
  siteDetailed = 'siteDetailed',
  unit = 'unit',
  patientNotes = 'patientNotes',
  patientWithStats = 'patientWithStats',
  patientWithEvents = 'patientWithEvents',
  patientWithSummaryReports = 'patientWithSummaryReports',
  patientWithMappingReports = 'patientWithMappingReports',
  patientWithDetailedReports = 'patientWithDetailedReports',
  patientWithActigraphyReports = 'patientWithActigraphyReports',
  patientWithLiveDataLatest = 'patientWithLiveDataLatest',
  patientWithLatestVisit = 'patientWithLatestVisit',
  patientWithExerciseSummarys = 'patientWithExerciseSummarys',
  shiftReport = 'shiftReport',
  unitRoundReport = 'unitRoundReport',
  watchList = 'watchList',
  monthlyCosts = 'monthlyCosts',
}
